import { DownloadHistory } from '../../../utils/headers';
import Loading from '../../Loading';
import DataTable from '../../Table/DataTable';

function HistorialDescargas({ items, loading }: any) {
    return loading ? (
        <Loading />
    ) : (
        <DataTable headers={DownloadHistory} loading={loading} options={items} />
    );
}

export default HistorialDescargas;
